/**
 * Admin Dashboard Page
 * 
 * Main dashboard for admin users.
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Container,
  Typography,
  Button,
  Card,
  CardContent,
  Grid,
} from '@mui/material';
import PostAddIcon from '@mui/icons-material/PostAdd';
import ListIcon from '@mui/icons-material/List';
import ProtectedRoute from '../../components/admin/ProtectedRoute';
import Breadcrumbs from '../../components/admin/Breadcrumbs';

const AdminDashboard: React.FC = () => {
  const navigate = useNavigate();

  return (
    <ProtectedRoute>
      <Box>
        <Container maxWidth="lg" sx={{ py: 4 }}>
          {/* Breadcrumbs */}
          <Breadcrumbs items={[{ label: 'Admin Dashboard' }]} />

          <Typography variant="h4" component="h1" gutterBottom>
            Welcome to Admin Dashboard
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
            Manage your blog posts and content from here.
          </Typography>

          <Grid container spacing={3}>
            {/* Blog Management Card */}
            <Grid item xs={12} md={6}>
              <Card>
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    Blog Management
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    Create, edit, and manage your blog posts
                  </Typography>
                  <Button
                    variant="contained"
                    startIcon={<ListIcon />}
                    onClick={() => navigate('/admin/blog')}
                    fullWidth
                  >
                    Manage Blog Posts
                  </Button>
                </CardContent>
              </Card>
            </Grid>

            {/* Quick Actions Card */}
            <Grid item xs={12} md={6}>
              <Card>
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    Quick Actions
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    Create a new blog post
                  </Typography>
                  <Button
                    variant="outlined"
                    startIcon={<PostAddIcon />}
                    onClick={() => navigate('/admin/blog/new')}
                    fullWidth
                  >
                    New Blog Post
                  </Button>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </ProtectedRoute>
  );
};

export default AdminDashboard;

